/*
 * DynamicFieldForm Messages
 *
 * This contains all the text for the DynamicFieldForm component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'src.pages.DynamicFieldsPage.components.DynamicFieldForm';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Dynamic Field',
  },
  createDynamicFieldButtonLabel: {
    id: `${scope}.createDynamicFieldButtonLabel`,
    defaultMessage: 'Create dynamic field',
  },
  nameEnLabel: {
    id: `${scope}.nameEnLabel`,
    defaultMessage: 'Label EN',
  },
  nameDeLabel: {
    id: `${scope}.nameDeLabel`,
    defaultMessage: 'Label DE',
  },
  typeLabel: {
    id: `${scope}.typeLabel`,
    defaultMessage: 'Type',
  },
  categoryLabel: {
    id: `${scope}.categoryLabel`,
    defaultMessage: 'Category',
  },
  descriptionLabel: {
    id: `${scope}.descriptionLabel`,
    defaultMessage: 'Description',
  },
  positionLabel: {
    id: `${scope}.positionLabel`,
    defaultMessage: 'Position',
  },
  visibleByAdminLabel: {
    id: `${scope}.visibleByAdminLabel`,
    defaultMessage: 'Visible in Staffing',
  },
  visibleByUserLabel: {
    id: `${scope}.visibleByUserLabel`,
    defaultMessage: 'Visible By User',
  },
  questionEnLabel: {
    id: `${scope}.questionEnLabel`,
    defaultMessage: 'Question EN',
  },
  questionDeLabel: {
    id: `${scope}.questionDeLabel`,
    defaultMessage: 'Question DE',
  },
  helpTextEnLabel: {
    id: `${scope}.helpTextEnLabel`,
    defaultMessage: 'Help Text EN',
  },
  helpTextDeLabel: {
    id: `${scope}.helpTextDeLabel`,
    defaultMessage: 'Help Text DE',
  },
  shownToUsers: {
    id: `${scope}.shownToUsers`,
    defaultMessage: '(shown to users)',
  },
  yesLabel: {
    id: `${scope}.yesLabel`,
    defaultMessage: 'Yes',
  },
  noLabel: {
    id: `${scope}.noLabel`,
    defaultMessage: 'No',
  },
  editTooltip: {
    id: `${scope}.editTooltip`,
    defaultMessage: 'Edit',
  },
});
